import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import axios from "axios";

export default function BusinessEntry() {
  const { slug } = useParams();
  const [state, setState] = useState(null);
  useEffect(() => {
    sessionStorage.setItem("ip_biz", slug);
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/business/${slug}`).then(() => setState("ok")).catch(() => setState("missing"));
  }, [slug]);
  if (state === "missing") return <div className="login fade" data-testid="business-missing"><h1>NO BUSINESS HERE</h1><p>That portal link doesn't exist. Check the link your coach sent you.</p></div>;
  if (state === "ok") return <Navigate to={`/login?b=${slug}`} replace />;
  return <div className="center"><span className="spin" /></div>;
}
